module.exports = __webpack_public_path__ + "img/icon-no-address.svg";